import React, {useState} from "react";
import {Box, Checkbox, Grid, List, ListItem, TextField, Tooltip, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

const ColumnSelectionRow = ({column, onChange}) => {
  return (
    <ListItem className="etl-wizard__list__body__item">
      <Grid container className="etl-wizard__list__body__row">
        <Grid className="etl-wizard__column-selection__item__fields__checkboxes">
          <Checkbox
            className="etl-wizard__column-selection__item__import-field"
            checked={column.import}
            onChange={e => onChange({...column, import: e.target.checked})}
          />
        </Grid>
        <Grid size={4} className="etl-wizard__column-selection__item__column-name">
          <Tooltip title={column.name}>
            <Typography>{column.name}</Typography>
          </Tooltip>
        </Grid>
        <Grid size={"grow"}>
          <TextField
            className="etl-wizard__column-selection__item__alias-field"
            variant="outlined"
            value={column.alias}
            onChange={e => onChange({...column, alias: e.target.value})}
            error={column.hasError}
            required={column.import}
            disabled={!column.import}
            fullWidth
          />
        </Grid>
      </Grid>
    </ListItem>
  );
};

const EtlWizardStepColumn = ({columns, setColumns, errorMessage}) => {
  const {t} = useTranslation();

  const [allChecked, setAllChecked] = useState(true);

  const handleSelectAllColumns = () => {
    setAllChecked(true);
    setColumns(columns.map(column => ({...column, import: true})));
  };
  const handleDeselectAllColumns = () => {
    setAllChecked(false);
    setColumns(columns.map(column => ({...column, import: false})));
  };
  const handleColumnChange = updatedColumn => {
    const updatedColumns = columns.map(column => (column.name === updatedColumn.name ? updatedColumn : column));
    setAllChecked(!updatedColumns.some(column => column.import === false));
    setColumns(updatedColumns);
  };

  return (
    <Box
      className="etl-wizard__step-column"
      sx={
        errorMessage
          ? {
              marginTop: "16px",
              height: "calc(100% - 200px)"
            }
          : {
              marginTop: "24px",
              height: "calc(100% - 150px)"
            }
      }
    >
      <List className="etl-wizard__list__header">
        <ListItem className="etl-wizard__list__header__item">
          <Grid container className="etl-wizard__list__header__row">
            <Grid>
              <Tooltip
                title={
                  allChecked
                    ? t("modules.packageManager.etlWizard.columnSelection.headers.deselectAll.label")
                    : t("modules.packageManager.etlWizard.columnSelection.headers.selectAll.label")
                }
              >
                <Checkbox
                  className="etl-wizard__column-selection__select-deselect-all"
                  checked={allChecked}
                  onChange={() => (allChecked ? handleDeselectAllColumns() : handleSelectAllColumns())}
                />
              </Tooltip>
            </Grid>
            <Grid size={4}>
              <Typography variant="p">
                {t("modules.packageManager.etlWizard.columnSelection.headers.column.label")}
              </Typography>
            </Grid>
            <Grid size={"grow"}>
              <Typography variant="p">
                {t("modules.packageManager.etlWizard.columnSelection.headers.alias.label")}
              </Typography>
            </Grid>
          </Grid>
        </ListItem>
      </List>
      <List className="etl-wizard__list__body">
        {columns.map(column => (
          <ColumnSelectionRow
            key={column.name}
            column={column}
            onChange={handleColumnChange}
            setAllChecked={setAllChecked}
          />
        ))}
      </List>
    </Box>
  );
};

export default EtlWizardStepColumn;
